import * as React from "react";
import { useNavigationHistory } from "src/hooks/useNavigationHistory";

// This component should be added to your main App component to ensure
// navigation history is always being tracked, even before login
export const NavigationTracker: React.FC = () => {
  // This will track all navigation automatically
  useNavigationHistory(10); // Track last 10 paths
  
  // This component doesn't render anything, it just tracks navigation
  return null;
};

// Alternative: A visible tracker for debugging
export const NavigationTrackerDebug: React.FC = () => {
  const history = useNavigationHistory(10);
  
  return (
    <div style={{ 
      position: 'fixed', 
      top: 10, 
      right: 10, 
      background: 'rgba(0,0,0,0.8)', 
      color: 'white', 
      padding: '10px', 
      borderRadius: '5px',
      fontSize: '12px',
      zIndex: 9999,
      maxWidth: '300px'
    }}>
      <strong>Navigation History ({history.length}):</strong>
      {history.map((path, index) => (
        <div key={index} style={{ margin: '2px 0' }}>
          {index + 1}. {path}
        </div>
      ))}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/shared/components/NavigationTracker.tsx